import React from 'react';

import { ReactComponent as ArrowDown } from '../../assets/arrow-down.svg';
import GenericLogo from '../../assets/company-placeholder.png';

import { GetStakeholderLogoUrl } from '../../services/ApiServices';


type HeaderProps = {
    advertiserName: string,
    advertiserId: number,
    advertiserLogo: string,
    clickRevoke: Function,
    isRevokeButtonsDisabled: boolean,
    showRevoke: boolean
}


function OwnerConsentsAdvertiserBar(props: HeaderProps) {
    let { advertiserName, advertiserId, advertiserLogo, clickRevoke, isRevokeButtonsDisabled, showRevoke } = props;


    return (
        <>
            <div className="company-info">
                <div className="user-img">
                    { advertiserLogo === null || advertiserLogo === 'null' || advertiserLogo === '' ?
                        <img src={ GenericLogo } alt="Logo" />
                    :
                        <img src={GetStakeholderLogoUrl(advertiserId)} alt={advertiserName + ' logo'} />
                    }
                </div>
                <p className={ !showRevoke ? 'revoked' : undefined }>{advertiserName}</p>
            </div>
            
            <div className="btn-container align-right">
                { showRevoke ?
                        <button type="button" className="btn btn-delete" disabled={isRevokeButtonsDisabled}
                            onClick={() => { clickRevoke(advertiserId, false)}} >Tilbagekald</button>
                    :
                    <div className="company-info">
                        <p className="revoked">Tilbagekaldt</p>&nbsp;&nbsp;
                    </div>
                }

                <span className="toggle-icon"><ArrowDown /></span>
            </div>
        </>
    );
}

export default OwnerConsentsAdvertiserBar;